import React, {useEffect,useState} from "react";

import {FaArrowLeft} from "react-icons/fa";
import {useNavigate} from "react-router-dom";
import {BackButton, HeaderLeft, Title, Container, MainSection, Content, Header} from "../common/styles";

const Absences = () => {
  const navigate = useNavigate()
  const handleBack = () => {
    navigate('/');
  };

  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const loadWebComponent = async () => {
      try {
        const script = document.createElement('script');
        script.type = 'module';
        // Always use the Azure URL for now until CORS is fixed
        script.src = import.meta.env.VITE_ABSENCES_COMPONENT_URL;
        //script.src = '/absences-component/index.js';
        script.onload = () => {
          setLoaded(true);
        };
        document.head.appendChild(script);
      } catch (err) {
        console.error('Error:', err);
        setError(true);
      }
    };

    loadWebComponent();
  }, []);

  return (
  <Container>
    <Header>
      <HeaderLeft>
        <BackButton onClick={handleBack}>
          <FaArrowLeft /> Back to Home
        </BackButton>
        <Title>My Availability</Title>
      </HeaderLeft>
    </Header>
    <Content>
      <MainSection style={{ padding:'0px' }}>
        {error && <p>Couldn't load web component</p>}
        {loaded && <absences-component></absences-component>}
      </MainSection>
    </Content>
  </Container>
  );
};

export default Absences;
